import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminService } from '../../services';
import { useUser } from '../../context/UserContext';
import { AdminPageHeader, DataTable, shortDate, money } from '../../components/admin/shell';

/** ENGINES › PLANNER — spec/sections.md §22. Names the switch when it is off. */
export default function PlannerPage() {
  const { can } = useUser();
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => { setLoading(true); const r = await adminService.getPlans(page, 20); setLoading(false); if (r.success) setData(r.data); })(); }, [page]);
  const enabled = data?.enabled;
  const empty = enabled === false
    ? <>PLANNER IS OFF. TURN ON PLANNER_ENABLED IN {can('settings', 'view') ? <Link to="/admin/settings" className="underline">SETTINGS</Link> : 'SETTINGS'}.</>
    : 'NOTHING HERE YET.';
  return (
    <>
      <AdminPageHeader section="planner" meta={enabled ? 'Every plan a host has started.' : 'Behind planner_enabled. Off in production today.'} />
      <DataTable
        columns={[
          { key: 'prompt', label: 'PLAN', fr: 2, render: (p) => p.prompt || '—' },
          { key: 'ownerEmail', label: 'OWNER', fr: 1.4, render: (p) => p.ownerName || p.ownerEmail || '—' },
          { key: 'stage', label: 'STAGE', fr: 1, render: (p) => String(p.stage || '').toUpperCase() },
          { key: 'spentCents', label: 'SPENT', fr: 0.9, right: true, render: (p) => money(p.spentCents) },
          { key: 'createdAt', label: 'CREATED', fr: 1, render: (p) => shortDate(p.createdAt) },
          { key: 'status', label: 'STATUS', fr: 0.9, render: (p) => String(p.status || '').toUpperCase() },
        ]}
        rows={data?.plans || []}
        loading={loading}
        empty={empty}
        total={data?.total ?? 0}
        page={page}
        pageSize={20}
        onPage={setPage}
        footerLeft={`${(data?.total ?? 0).toLocaleString()} plans`}
      />
    </>
  );
}
